import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from '@angular/fire/compat/firestore';
import { reviewExperience } from '../models/ToursModels/review';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Ng2ImgMaxService } from 'ng2-img-max';

const TABLE = 'reviews';
const FIRESTORAGE_BASE_PATH = 'reviews';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  private loadDataReviews = new BehaviorSubject<any>(0);
  public loadReviews$ = this.loadDataReviews.asObservable();

  private collectionRef: AngularFirestoreCollection<reviewExperience>;

  constructor(
    private db: AngularFirestore,
    public fireStorage: AngularFireStorage,
    private ng2ImgMax: Ng2ImgMaxService
  ) {
    this.collectionRef = this.db.collection(TABLE);
  }

  saveReviewExperience(review: reviewExperience) {
    return this.collectionRef.add(review);
  }

  uploadImageReview(file: any, filename: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const cleanedBase64 = file.replace(/^data:image\/\w+;base64,/, '');
      const blob = this.base64ToBlob(cleanedBase64, 'image/png');
      const fileObject = new File([blob], filename, { type: 'image/png' });

        // Comprime la imagen usando Ng2ImgMaxService 500kb max
      this.ng2ImgMax.compressImage(fileObject, 0.5, true).subscribe({
        next: (result) => {
          const compressedFile = new File([result], filename, { type: 'image/png' });
          const filePath = `${FIRESTORAGE_BASE_PATH}/${filename}`;
          const ref = this.fireStorage.ref(filePath);
          const task = ref.put(compressedFile);

          task.snapshotChanges().pipe(
            finalize(() => {
              ref.getDownloadURL().subscribe({
                next: (url) => resolve(url),
                error: (getUrlError) => reject(getUrlError),
              });
            })
          ).subscribe();
        },
        error: (compressionError) => {
          console.error('Error al procesar la imagen:', compressionError);
          reject(compressionError);
        },
      });
    });
  }

  base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: type });
  }


  getReviewsIdExperience(experienceId: string) {
    return this.db
      .collection<reviewExperience>(TABLE, (ref) =>
        ref
          .where('experienceId', '==', experienceId)
          .orderBy('rating', 'desc')
          .orderBy('date', 'desc')
      )
      .valueChanges({ idField: '_id' })
  }

  reviewsDataShared(data?: any) {
    if (data == null) {
      return this.loadDataReviews.getValue();
    }
    this.loadDataReviews.next(data);
    return this.loadDataReviews.getValue();
  }
}
